module.exports = __webpack_public_path__ + "img/works_ssWells_e_btm_off.f66c99b2.png";